export function convertToBoolean(input: string | boolean): boolean {
  if (input) {
    return typeof input === 'boolean' ? input : input === 'true';
  }
}
